import { createBrowserClient } from '@supabase/ssr'
import type { User } from '@supabase/supabase-js'

/**
 * Create a Supabase browser client for client-side usage.
 */
export function createClient() {
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
  )
}
// Types for authentication
export type AuthUser = User

export type AuthError = {
  message: string
}
